<ng-container *transloco="let t">
  <div class="grid-table-box">
    <div class="grid-table">
      <div class="grid-header">
        <div class="grid-cell">{{ t('league.rank') }}</div>
        <div class="grid-cell">{{ t('league.name.and.last.name') }}</div>
        <div class="grid-cell">{{ t('app.common.country') }}</div>
        <div class="grid-cell">{{ t('league.points') }}</div>
        <div class="grid-cell">{{ t('app.common.category') }}</div>
        <div class="grid-cell">Race 1</div>
        <div class="grid-cell">Race 2</div>
        <div class="grid-cell">Race 3</div>
        <div class="grid-cell">Race 4</div>
        <div class="grid-cell">Race 5</div>
      </div>

      <div class="grid-row">
        <div class="grid-cell">
          <div class="fw-semibold">1</div>
        </div>
        <div class="grid-cell">
          <div class="fw-semibold"> Name and last name</div>
        </div>
        <div class="grid-cell">Croatia</div>
        <div class="grid-cell">600</div>
        <div class="grid-cell">M3</div>
        <div class="grid-cell">00</div>
        <div class="grid-cell">00</div>
        <div class="grid-cell">00</div>
        <div class="grid-cell">00</div>
        <div class="grid-cell">00</div>
      </div>

      <div class="grid-row">
        <div class="grid-cell">
          <div class="fw-semibold">1</div>
        </div>
        <div class="grid-cell">
          <div class="fw-semibold"> Name and last name</div>
        </div>
        <div class="grid-cell">Croatia</div>
        <div class="grid-cell">600</div>
        <div class="grid-cell">M3</div>
        <div class="grid-cell">00</div>
        <div class="grid-cell">00</div>
        <div class="grid-cell">00</div>
        <div class="grid-cell">00</div>
        <div class="grid-cell">00</div>
      </div>

      <div class="grid-row">
        <div class="grid-cell">
          <div class="fw-semibold">1</div>
        </div>
        <div class="grid-cell">
          <div class="fw-semibold"> Name and last name</div>
        </div>
        <div class="grid-cell">Croatia</div>
        <div class="grid-cell">600</div>
        <div class="grid-cell">M3</div>
        <div class="grid-cell">00</div>
        <div class="grid-cell">00</div>
        <div class="grid-cell">00</div>
        <div class="grid-cell">00</div>
        <div class="grid-cell">00</div>
      </div>
    </div>
  </div>
</ng-container>
